import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Header from './components/layout/Header';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import UploadPage from './pages/UploadPage';
import DocumentViewerPage from './pages/DocumentViewerPage';
import DocumentPreviewPage from './pages/DocumentPreviewPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AnonymousUploadPage from './pages/AnonymousUploadPage';
import AnonymousViewerPage from './pages/AnonymousViewerPage';
import ProfilePage from './pages/ProfilePage';
import PermissionsPage from './pages/PermissionsPage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import DataDeletionPage from './pages/DataDeletionPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import LoadingSpinner from './components/common/LoadingSpinner';
import './App.css';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/dashboard" />} />
          <Route path="/register" element={!user ? <RegisterPage /> : <Navigate to="/dashboard" />} />
          <Route path="/forgot-password" element={!user ? <ForgotPasswordPage /> : <Navigate to="/dashboard" />} />
          <Route path="/reset-password" element={!user ? <ResetPasswordPage /> : <Navigate to="/dashboard" />} />
          <Route path="/" element={!user ? <AnonymousUploadPage /> : <Navigate to="/dashboard" />} />
          <Route path="/view/:documentId" element={<AnonymousViewerPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/data-deletion" element={<DataDeletionPage />} />
          <Route path="/verify" element={<EmailVerificationPage />} />
          <Route path="/oauth/:provider/callback" element={<OAuthCallbackPage />} />

          {/* Protected routes */}
          <Route 
            path="/dashboard" 
            element={user ? <DashboardPage /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/upload" 
            element={user ? <UploadPage /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/documents/:documentId" 
            element={user ? <DocumentViewerPage /> : <Navigate to="/login" />} 
          />
          <Route
            path="/documents/:documentId/preview"
            element={user ? <DocumentPreviewPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/documents/:documentId/analytics"
            element={user ? <AnalyticsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/documents/:documentId/permissions"
            element={user ? <PermissionsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/profile"
            element={user ? <ProfilePage /> : <Navigate to="/login" />}
          />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to={user ? "/dashboard" : "/"} />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;